"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SimpleModal_1 = require("./SimpleModal");
exports.default = SimpleModal_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/SimpleModal/index.js
// module id = 659
// module chunks = 8